import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

/**
 * Create or update school's return address
 * @param {number} schoolId
 * @param {Object} payload
 * @param {string} version
 */
export const createOrUpdateReturnAddress = ({
  schoolId,
  payload,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/transcripts/return-addresses/${schoolId}/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Get a List of School Return Addresses
 * @param {string} version
 */
export const getSchoolReturnAddressList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/transcripts/return-addresses/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Get School Return Address Details
 * @param {string} version
 */
export const getSchoolReturnAddressDetails = ({
  schoolId,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/transcripts/return-addresses/${schoolId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
